import { render, staticRenderFns } from "./PersonnelGallery.vue?vue&type=template&id=33e6a568&scoped=true"
import script from "./PersonnelGallery.vue?vue&type=script&lang=js"
export * from "./PersonnelGallery.vue?vue&type=script&lang=js"
import style0 from "./PersonnelGallery.vue?vue&type=style&index=0&id=33e6a568&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e6a568",
  null
  
)

export default component.exports